// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MOBILE SCREENER HEATMAP — Card layout
   Scoped to small-width viewports AND short-height landscape phones.
   Reuses tokens from MobileScreener.css where defined.
   ============================================ */

@media (max-width: 768px),
       (max-height: 500px) and (orientation: landscape) {
  /* ============================================
     ROOT CONTAINER
     ============================================ */
  .mhm-root {
    width: 100%;
    color: #ffffff;
    /* Clear the 52px MobileScreenerContextBar that sits just above the bottom
       nav. The App-level pb-[80px] already clears the bottom nav itself. */
    padding-bottom: 76px;
  }

  /* ============================================
     SUMMARY HEADER (sticky at top)
     ============================================ */
  .mhm-summary {
    position: sticky;
    top: 0;
    z-index: 30;
    background: #0a0a0a;
    border-bottom: 1px solid #333;
    padding: 10px 12px;
    margin-bottom: 12px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr auto;
    gap: 8px;
    align-items: center;
  }

  .mhm-summary-item {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .mhm-summary-label {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #888;
    line-height: 1.2;
  }

  .mhm-summary-value {
    font-size: 13px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mhm-summary-gear {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #1a1a1a;
    border: 1px solid #333;
    color: #b0b0b0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .mhm-summary-gear:hover,
  .mhm-summary-gear:focus {
    border-color: #218aff;
    color: #218aff;
    outline: none;
  }

  /* ============================================
     CONTROL ROW (above cards): display mode toggle,
     favorites filter, share, export
     ============================================ */
  .mhm-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 12px 10px;
    align-items: center;
  }

  .mhm-controls .mhm-controls-group {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  /* ============================================
     CARD LIST — edge-to-edge, Robinhood-style
     ============================================ */
  .mhm-card-list {
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  /* ============================================
     CONTRACT CARD — flat row with thin separator
     ============================================ */
  .mhm-card {
    background: transparent;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #1f1f1f;
    padding: 12px 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    transition: background-color 0.15s ease;
  }

  .mhm-card:last-child {
    border-bottom: none;
  }

  .mhm-card:active {
    background: rgba(255, 255, 255, 0.02);
  }

  /* ---- Header (identity + expiration) ---- */
  .mhm-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
  }

  .mhm-card-identity {
    flex: 1 1;
    min-width: 0;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    text-align: left;
    color: #ffffff;
    cursor: pointer;
  }

  .mhm-card-identity:hover .mhm-card-ticker,
  .mhm-card-identity:focus .mhm-card-ticker {
    color: #218aff;
  }

  .mhm-card-identity:focus {
    outline: none;
  }

  .mhm-card-identity-line1 {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.2;
    flex-wrap: wrap;
  }

  .mhm-card-ticker {
    color: #ffffff;
    font-size: 15px;
    font-weight: 700;
    transition: color 0.15s ease;
  }

  .mhm-card-position {
    font-size: 11px;
    color: #e0e0e0;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 2px 6px;
    background: #2a2a2a;
    border-radius: 4px;
    font-weight: 500;
  }

  .mhm-card-option-type {
    font-size: 11px;
    color: #e0e0e0;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-weight: 600;
  }

  .mhm-card-ext-icon {
    width: 12px;
    height: 12px;
    color: #888;
  }

  .mhm-card-identity-line2 {
    font-size: 13px;
    color: #e0e0e0;
    line-height: 1.5;
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mhm-card-expiration {
    font-size: 13px;
    color: #e0e0e0;
    font-weight: 600;
    white-space: nowrap;
    text-align: right;
    flex-shrink: 0;
    padding-top: 1px;
  }

  /* ---- Action row ---- */
  .mhm-card-actions {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .mhm-action-btn {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: #0f0f0f;
    border: 1px solid #333;
    color: #b0b0b0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    padding: 0;
  }

  .mhm-action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .mhm-action-btn-favorited {
    color: #facc15;
    border-color: #facc15;
    background: rgba(250, 204, 21, 0.1);
  }

  .mhm-action-btn-remove:hover {
    border-color: #ef4444;
    color: #ef4444;
    background: rgba(239, 68, 68, 0.1);
  }

  .mhm-action-btn:hover:not(:disabled):not(.mhm-action-btn-remove) {
    border-color: #218aff;
    color: #218aff;
    background: rgba(33, 138, 255, 0.1);
  }

  .mhm-action-icon {
    width: 14px;
    height: 14px;
  }

  .mhm-action-spinner {
    width: 12px;
    height: 12px;
    border: 2px solid #444;
    border-top-color: #218aff;
    border-radius: 50%;
    animation: mhm-spin 0.8s linear infinite;
  }

  @keyframes mhm-spin {
    to { transform: rotate(360deg); }
  }

  .mhm-action-link {
    margin-left: auto;
    font-size: 11px;
    color: #218aff;
    text-decoration: none;
    padding: 4px 8px;
    border: 1px solid rgba(33, 138, 255, 0.4);
    border-radius: 6px;
    transition: all 0.15s ease;
  }

  .mhm-action-link:hover {
    background: rgba(33, 138, 255, 0.15);
    border-color: #218aff;
  }

  /* ---- Chip strip — breaks out of the card's content padding so it
          scrolls edge-to-edge with the viewport (matching the Robinhood
          horizontal-row pattern). First chip stays visually aligned with the
          card identity via the inner padding-left. ---- */
  .mhm-chip-strip {
    display: flex;
    gap: 6px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x proximity;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: #333 transparent;
    padding-bottom: 4px;
    margin-left: -12px;
    margin-right: -12px;
    padding-left: 12px;
    padding-right: 12px;
  }

  .mhm-chip-strip::-webkit-scrollbar {
    height: 4px;
  }

  .mhm-chip-strip::-webkit-scrollbar-track {
    background: transparent;
  }

  .mhm-chip-strip::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 2px;
  }

  .mhm-chip {
    min-width: 60px;
    max-width: 72px;
    height: 48px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    padding: 4px 6px;
    scroll-snap-align: start;
    transition: transform 0.1s ease, border-color 0.15s ease;
    /* backgroundColor comes from inline style via getHeatmapCellColor */
  }

  .mhm-chip:hover {
    transform: translateY(-1px);
  }

  .mhm-chip-active {
    border-color: #ffffff;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
  }

  .mhm-chip-scenario {
    font-size: 11px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.95);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    line-height: 1;
  }

  .mhm-chip-value {
    font-size: 12px;
    font-weight: 700;
    line-height: 1.1;
    margin-top: 3px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  }

  /* ---- Chip detail (expanded) ---- */
  .mhm-chip-detail {
    background: #0f0f0f;
    border: 1px solid #2a2a2a;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 12px;
    color: #d4d4d4;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .mhm-chip-detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  .mhm-chip-detail-label {
    color: #888;
    font-size: 11px;
  }

  .mhm-chip-detail-breakeven {
    border-top: 1px solid #2a2a2a;
    padding-top: 4px;
    margin-top: 2px;
  }

  /* ============================================
     LEGEND STRIP (bottom)
     ============================================ */
  .mhm-legend {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
    padding: 14px 12px 4px;
    overflow-x: auto;
  }

  .mhm-legend-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }

  .mhm-legend-swatch {
    width: 28px;
    height: 14px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.08);
  }

  .mhm-legend-label {
    font-size: 10px;
    color: #888;
    white-space: nowrap;
  }

  /* ============================================
     SCROLL HINT
     ============================================ */
  .mhm-scroll-hint {
    text-align: center;
    font-size: 11px;
    color: #666;
    padding: 6px 12px 0;
  }

  /* ============================================
     RESULTS COUNT (above legend)
     ============================================ */
  .mhm-result-count {
    font-size: 12px;
    color: #888;
    text-align: center;
    padding: 8px 12px 0;
  }

  /* ============================================
     SLIDE-UP SHEET (Settings + Filters)
     ============================================ */
  .mhm-sheet-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1100;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease;
  }

  .mhm-sheet-backdrop.mhm-sheet-open {
    opacity: 1;
    pointer-events: auto;
  }

  .mhm-sheet {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1101;
    background: #0f0f0f;
    border-top: 1px solid #333;
    border-radius: 16px 16px 0 0;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    transform: translateY(100%);
    transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);
    padding-bottom: env(safe-area-inset-bottom, 0);
  }

  .mhm-sheet.mhm-sheet-open {
    transform: translateY(0);
  }

  .mhm-sheet-handle-bar {
    width: 40px;
    height: 4px;
    background: #444;
    border-radius: 2px;
    margin: 8px auto 4px;
    flex-shrink: 0;
  }

  .mhm-sheet-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px 6px;
    border-bottom: 1px solid #222;
    flex-shrink: 0;
  }

  .mhm-sheet-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
  }

  .mhm-sheet-close {
    background: transparent;
    border: none;
    color: #888;
    font-size: 20px;
    cursor: pointer;
    padding: 4px 8px;
    line-height: 1;
  }

  .mhm-sheet-close:hover {
    color: #ffffff;
  }

  .mhm-sheet-body {
    overflow-y: auto;
    padding: 12px 12px 16px;
    flex: 1 1;
    min-height: 0;
  }
}

/* ============================================
   LANDSCAPE TIGHTENING — page chrome
   Layered on top of the rules above when the phone is rotated to
   landscape. Reclaims vertical space from the page header, count row,
   and sync-hint banner so the heatmap grid gets more of the ~310px
   landscape body.
   ============================================ */
@media (max-height: 500px) and (orientation: landscape) {
  /* Page header shrinks (class added in ElasticityHeatmapView.js so the
     rule doesn't depend on tree position). !important is needed because
     the corresponding JSX still sets inline padding/font-size. */
  .mhm-page-header {
    padding: 2px 12px 2px !important;
  }

  .mhm-page-title {
    font-size: 13px !important;
    line-height: 1.15 !important;
  }

  .mhm-page-subtitle {
    font-size: 10px !important;
    margin-top: 0 !important;
  }

  /* Sync hint — redundant in landscape since columns are already visible */
  .mhm-sync-hint {
    display: none !important;
  }

  /* Bottom padding only needs to clear the (now shorter) context bar */
  .mhm-root {
    padding-bottom: 56px;
  }

  /* Sheet — limit to a tighter cap so most of the heatmap still shows
     when the sheet is open. */
  .mhm-sheet {
    max-height: 92vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MobileScreenerHeatmap.css"],"names":[],"mappings":"AAAA;;;;iDAIiD;;AAEjD;;EAEE;;mDAEiD;EACjD;IACE,WAAW;IACX,cAAc;IACd;2EACuE;IACvE,oBAAoB;EACtB;;EAEA;;mDAEiD;EACjD;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uCAAuC;IACvC,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;;IAEE,qBAAqB;IACrB,cAAc;IACd,aAAa;EACf;;EAEA;;;mDAGiD;EACjD;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,eAAe;EACjB;;EAEA;;mDAEiD;EACjD;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;;mDAEiD;EACjD;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uCAAuC;EACzC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,mCAAmC;EACrC;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,kCAAkC;EACpC;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,KAAK,yBAAyB,EAAE;EAClC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;EACvB;;EAEA;;;0DAGwD;EACxD;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;IACrB,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,wDAAwD;IACxD,oEAAoE;EACtE;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,8CAA8C;EAChD;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,yCAAyC;IACzC,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yCAAyC;EAC3C;;EAEA,qCAAqC;EACrC;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;mDAEiD;EACjD;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;;mDAEiD;EACjD;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;;mDAEiD;EACjD;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;mDAEiD;EACjD;IACE,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,0DAA0D;IAC1D,8CAA8C;EAChD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,SAAO;IACP,aAAa;EACf;AACF;;AAEA;;;;;;iDAMiD;AACjD;EACE;;iEAE+D;EAC/D;IACE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA,yEAAyE;EACzE;IACE,wBAAwB;EAC1B;;EAEA,qEAAqE;EACrE;IACE,oBAAoB;EACtB;;EAEA;8BAC4B;EAC5B;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* ============================================\n   MOBILE SCREENER HEATMAP — Card layout\n   Scoped to small-width viewports AND short-height landscape phones.\n   Reuses tokens from MobileScreener.css where defined.\n   ============================================ */\n\n@media (max-width: 768px),\n       (max-height: 500px) and (orientation: landscape) {\n  /* ============================================\n     ROOT CONTAINER\n     ============================================ */\n  .mhm-root {\n    width: 100%;\n    color: #ffffff;\n    /* Clear the 52px MobileScreenerContextBar that sits just above the bottom\n       nav. The App-level pb-[80px] already clears the bottom nav itself. */\n    padding-bottom: 76px;\n  }\n\n  /* ============================================\n     SUMMARY HEADER (sticky at top)\n     ============================================ */\n  .mhm-summary {\n    position: sticky;\n    top: 0;\n    z-index: 30;\n    background: #0a0a0a;\n    border-bottom: 1px solid #333;\n    padding: 10px 12px;\n    margin-bottom: 12px;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr auto;\n    gap: 8px;\n    align-items: center;\n  }\n\n  .mhm-summary-item {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .mhm-summary-label {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #888;\n    line-height: 1.2;\n  }\n\n  .mhm-summary-value {\n    font-size: 13px;\n    font-weight: 600;\n    color: #ffffff;\n    line-height: 1.3;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .mhm-summary-gear {\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    background: #1a1a1a;\n    border: 1px solid #333;\n    color: #b0b0b0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.15s ease;\n  }\n\n  .mhm-summary-gear:hover,\n  .mhm-summary-gear:focus {\n    border-color: #218aff;\n    color: #218aff;\n    outline: none;\n  }\n\n  /* ============================================\n     CONTROL ROW (above cards): display mode toggle,\n     favorites filter, share, export\n     ============================================ */\n  .mhm-controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 0 12px 10px;\n    align-items: center;\n  }\n\n  .mhm-controls .mhm-controls-group {\n    display: flex;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  /* ============================================\n     CARD LIST — edge-to-edge, Robinhood-style\n     ============================================ */\n  .mhm-card-list {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n\n  /* ============================================\n     CONTRACT CARD — flat row with thin separator\n     ============================================ */\n  .mhm-card {\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    border-bottom: 1px solid #1f1f1f;\n    padding: 12px 12px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    transition: background-color 0.15s ease;\n  }\n\n  .mhm-card:last-child {\n    border-bottom: none;\n  }\n\n  .mhm-card:active {\n    background: rgba(255, 255, 255, 0.02);\n  }\n\n  /* ---- Header (identity + expiration) ---- */\n  .mhm-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .mhm-card-identity {\n    flex: 1;\n    min-width: 0;\n    background: transparent;\n    border: none;\n    padding: 0;\n    margin: 0;\n    text-align: left;\n    color: #ffffff;\n    cursor: pointer;\n  }\n\n  .mhm-card-identity:hover .mhm-card-ticker,\n  .mhm-card-identity:focus .mhm-card-ticker {\n    color: #218aff;\n  }\n\n  .mhm-card-identity:focus {\n    outline: none;\n  }\n\n  .mhm-card-identity-line1 {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 1.2;\n    flex-wrap: wrap;\n  }\n\n  .mhm-card-ticker {\n    color: #ffffff;\n    font-size: 15px;\n    font-weight: 700;\n    transition: color 0.15s ease;\n  }\n\n  .mhm-card-position {\n    font-size: 11px;\n    color: #e0e0e0;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    padding: 2px 6px;\n    background: #2a2a2a;\n    border-radius: 4px;\n    font-weight: 500;\n  }\n\n  .mhm-card-option-type {\n    font-size: 11px;\n    color: #e0e0e0;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    font-weight: 600;\n  }\n\n  .mhm-card-ext-icon {\n    width: 12px;\n    height: 12px;\n    color: #888;\n  }\n\n  .mhm-card-identity-line2 {\n    font-size: 13px;\n    color: #e0e0e0;\n    line-height: 1.5;\n    margin-top: 2px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .mhm-card-expiration {\n    font-size: 13px;\n    color: #e0e0e0;\n    font-weight: 600;\n    white-space: nowrap;\n    text-align: right;\n    flex-shrink: 0;\n    padding-top: 1px;\n  }\n\n  /* ---- Action row ---- */\n  .mhm-card-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .mhm-action-btn {\n    width: 28px;\n    height: 28px;\n    border-radius: 6px;\n    background: #0f0f0f;\n    border: 1px solid #333;\n    color: #b0b0b0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    padding: 0;\n  }\n\n  .mhm-action-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  .mhm-action-btn-favorited {\n    color: #facc15;\n    border-color: #facc15;\n    background: rgba(250, 204, 21, 0.1);\n  }\n\n  .mhm-action-btn-remove:hover {\n    border-color: #ef4444;\n    color: #ef4444;\n    background: rgba(239, 68, 68, 0.1);\n  }\n\n  .mhm-action-btn:hover:not(:disabled):not(.mhm-action-btn-remove) {\n    border-color: #218aff;\n    color: #218aff;\n    background: rgba(33, 138, 255, 0.1);\n  }\n\n  .mhm-action-icon {\n    width: 14px;\n    height: 14px;\n  }\n\n  .mhm-action-spinner {\n    width: 12px;\n    height: 12px;\n    border: 2px solid #444;\n    border-top-color: #218aff;\n    border-radius: 50%;\n    animation: mhm-spin 0.8s linear infinite;\n  }\n\n  @keyframes mhm-spin {\n    to { transform: rotate(360deg); }\n  }\n\n  .mhm-action-link {\n    margin-left: auto;\n    font-size: 11px;\n    color: #218aff;\n    text-decoration: none;\n    padding: 4px 8px;\n    border: 1px solid rgba(33, 138, 255, 0.4);\n    border-radius: 6px;\n    transition: all 0.15s ease;\n  }\n\n  .mhm-action-link:hover {\n    background: rgba(33, 138, 255, 0.15);\n    border-color: #218aff;\n  }\n\n  /* ---- Chip strip — breaks out of the card's content padding so it\n          scrolls edge-to-edge with the viewport (matching the Robinhood\n          horizontal-row pattern). First chip stays visually aligned with the\n          card identity via the inner padding-left. ---- */\n  .mhm-chip-strip {\n    display: flex;\n    gap: 6px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scroll-snap-type: x proximity;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    scrollbar-color: #333 transparent;\n    padding-bottom: 4px;\n    margin-left: -12px;\n    margin-right: -12px;\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .mhm-chip-strip::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  .mhm-chip-strip::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .mhm-chip-strip::-webkit-scrollbar-thumb {\n    background: #333;\n    border-radius: 2px;\n  }\n\n  .mhm-chip {\n    min-width: 60px;\n    max-width: 72px;\n    height: 48px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    cursor: pointer;\n    padding: 4px 6px;\n    scroll-snap-align: start;\n    transition: transform 0.1s ease, border-color 0.15s ease;\n    /* backgroundColor comes from inline style via getHeatmapCellColor */\n  }\n\n  .mhm-chip:hover {\n    transform: translateY(-1px);\n  }\n\n  .mhm-chip-active {\n    border-color: #ffffff;\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);\n  }\n\n  .mhm-chip-scenario {\n    font-size: 11px;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.95);\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n    line-height: 1;\n  }\n\n  .mhm-chip-value {\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1.1;\n    margin-top: 3px;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n  }\n\n  /* ---- Chip detail (expanded) ---- */\n  .mhm-chip-detail {\n    background: #0f0f0f;\n    border: 1px solid #2a2a2a;\n    border-radius: 8px;\n    padding: 8px 10px;\n    font-size: 12px;\n    color: #d4d4d4;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .mhm-chip-detail-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .mhm-chip-detail-label {\n    color: #888;\n    font-size: 11px;\n  }\n\n  .mhm-chip-detail-breakeven {\n    border-top: 1px solid #2a2a2a;\n    padding-top: 4px;\n    margin-top: 2px;\n  }\n\n  /* ============================================\n     LEGEND STRIP (bottom)\n     ============================================ */\n  .mhm-legend {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 6px;\n    padding: 14px 12px 4px;\n    overflow-x: auto;\n  }\n\n  .mhm-legend-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    flex-shrink: 0;\n  }\n\n  .mhm-legend-swatch {\n    width: 28px;\n    height: 14px;\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  .mhm-legend-label {\n    font-size: 10px;\n    color: #888;\n    white-space: nowrap;\n  }\n\n  /* ============================================\n     SCROLL HINT\n     ============================================ */\n  .mhm-scroll-hint {\n    text-align: center;\n    font-size: 11px;\n    color: #666;\n    padding: 6px 12px 0;\n  }\n\n  /* ============================================\n     RESULTS COUNT (above legend)\n     ============================================ */\n  .mhm-result-count {\n    font-size: 12px;\n    color: #888;\n    text-align: center;\n    padding: 8px 12px 0;\n  }\n\n  /* ============================================\n     SLIDE-UP SHEET (Settings + Filters)\n     ============================================ */\n  .mhm-sheet-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.6);\n    z-index: 1100;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.25s ease;\n  }\n\n  .mhm-sheet-backdrop.mhm-sheet-open {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .mhm-sheet {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1101;\n    background: #0f0f0f;\n    border-top: 1px solid #333;\n    border-radius: 16px 16px 0 0;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    transform: translateY(100%);\n    transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);\n    padding-bottom: env(safe-area-inset-bottom, 0);\n  }\n\n  .mhm-sheet.mhm-sheet-open {\n    transform: translateY(0);\n  }\n\n  .mhm-sheet-handle-bar {\n    width: 40px;\n    height: 4px;\n    background: #444;\n    border-radius: 2px;\n    margin: 8px auto 4px;\n    flex-shrink: 0;\n  }\n\n  .mhm-sheet-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 16px 6px;\n    border-bottom: 1px solid #222;\n    flex-shrink: 0;\n  }\n\n  .mhm-sheet-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #ffffff;\n  }\n\n  .mhm-sheet-close {\n    background: transparent;\n    border: none;\n    color: #888;\n    font-size: 20px;\n    cursor: pointer;\n    padding: 4px 8px;\n    line-height: 1;\n  }\n\n  .mhm-sheet-close:hover {\n    color: #ffffff;\n  }\n\n  .mhm-sheet-body {\n    overflow-y: auto;\n    padding: 12px 12px 16px;\n    flex: 1;\n    min-height: 0;\n  }\n}\n\n/* ============================================\n   LANDSCAPE TIGHTENING — page chrome\n   Layered on top of the rules above when the phone is rotated to\n   landscape. Reclaims vertical space from the page header, count row,\n   and sync-hint banner so the heatmap grid gets more of the ~310px\n   landscape body.\n   ============================================ */\n@media (max-height: 500px) and (orientation: landscape) {\n  /* Page header shrinks (class added in ElasticityHeatmapView.js so the\n     rule doesn't depend on tree position). !important is needed because\n     the corresponding JSX still sets inline padding/font-size. */\n  .mhm-page-header {\n    padding: 2px 12px 2px !important;\n  }\n\n  .mhm-page-title {\n    font-size: 13px !important;\n    line-height: 1.15 !important;\n  }\n\n  .mhm-page-subtitle {\n    font-size: 10px !important;\n    margin-top: 0 !important;\n  }\n\n  /* Sync hint — redundant in landscape since columns are already visible */\n  .mhm-sync-hint {\n    display: none !important;\n  }\n\n  /* Bottom padding only needs to clear the (now shorter) context bar */\n  .mhm-root {\n    padding-bottom: 56px;\n  }\n\n  /* Sheet — limit to a tighter cap so most of the heatmap still shows\n     when the sheet is open. */\n  .mhm-sheet {\n    max-height: 92vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
